const React = require('react');

const { useMemo } = React;
const createRestClient = require('frontend-restclient');

const defaultConfig = {
  baseURL: '/',
};

const { useModuleContext } = require('../context/ModuleContext');

/**
 * useRestClient is a client-side customHook that provides you with a frontend-restclient instance
 * that is aware of it's execution context. It uses frontend-remote-modules ModuleContext
 * to decide what the base url of Ajax api calls in that context, whenever ModuleContext
 * is created or updated a new rest client will be created. It is useful when you develop
 * a component that will be rendered in multiple admins.
 */
const useRestClient = (customConfig) => {
  const moduleContext = useModuleContext();
  return useMemo(() => {
    const moduleConfig = moduleContext ? {
      baseURL: moduleContext.host,
      headers: {
        'csrf-token': moduleContext.csrfToken,
      },
      withCredentials: true,
    } : {};
    return createRestClient({
      ...defaultConfig,
      ...moduleConfig,
      ...(customConfig || {}),
    });
  }, [moduleContext, customConfig]);
};

module.exports = useRestClient;
